// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2jrb7","content":"Consent_content__2nx79","footer":"Consent_footer__1xCW9"};